import ConfirmationModal from './ConfirmationModal';

interface IDeleteWarningModale {
  header: string;
  onClose: () => void;
  open: boolean;
  handleDelete: () => void | Promise<void>;
}

const DeleteWarningModal = ({ header, handleDelete, open, onClose }: IDeleteWarningModale) => (
  <ConfirmationModal
    header={header}
    confirmLabel="Supprimer"
    open={open}
    onClose={onClose}
    handleConfirm={handleDelete}
  />
);

export default DeleteWarningModal;
